import { InjectionToken, Provider } from '@angular/core';
import {
  BenefitSplitLimits,
  BonusHistory,
  BonusStatus,
  ForemanPromocode,
  ForemanPromocodesList,
  PersonalManager,
  PersonalManagersList,
  SearchOrderDocumentResult,
} from '@my-account/const';
import { ActionReducerMap, combineReducers } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import {
  ACCEPT_MANAGER,
  BENEFIT_SPLIT_LIMITS,
  BONUS_HISTORY,
  BONUS_STATUS,
  DELETE_MANAGER,
  FOREMAN_PROMOCODES_LIST,
  GENERATED_PROMOCODE,
  MyAccountState,
  PERSONAL_MANAGERS_LIST,
  PERSONAL_MANAGER_CONFIRMATION,
  REVOKE_MANAGER,
  SEARCH_ORDER_DOCUMENT_ENTITY,
} from '../my-account-state';

export function getReducers(): ActionReducerMap<MyAccountState> {
  return {
    approveManager: StateUtils.entityLoaderReducer<string>(ACCEPT_MANAGER),
    revokeManager: StateUtils.entityLoaderReducer<string>(REVOKE_MANAGER),
    deleteManager: StateUtils.entityLoaderReducer<string>(DELETE_MANAGER),
    orderDocument: combineReducers({
      search: StateUtils.loaderReducer<SearchOrderDocumentResult>(SEARCH_ORDER_DOCUMENT_ENTITY),
    }),
    personalManagerConfirmation: StateUtils.loaderReducer<PersonalManager>(PERSONAL_MANAGER_CONFIRMATION),
    personalManagersList: StateUtils.loaderReducer<PersonalManagersList>(PERSONAL_MANAGERS_LIST),
    bonusHistory: StateUtils.loaderReducer<BonusHistory>(BONUS_HISTORY),
    bonusStatus: StateUtils.loaderReducer<BonusStatus>(BONUS_STATUS),
    foremanPromocodes: combineReducers({
      benefitSplitLimits: StateUtils.loaderReducer<BenefitSplitLimits>(BENEFIT_SPLIT_LIMITS),
      generatedPromocode: StateUtils.loaderReducer<ForemanPromocode>(GENERATED_PROMOCODE),
      list: StateUtils.loaderReducer<ForemanPromocodesList>(FOREMAN_PROMOCODES_LIST),
    }),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<MyAccountState>> = new InjectionToken<
  ActionReducerMap<MyAccountState>
>('MyAccountReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
